import React, { useState, useEffect } from "react";
import Header from "../components/HeaderA";

const translations = {
  el: {
    title: "Σχετικά με εμάς",
    whoTitle: "Ποιοι είμαστε",
    whoText: "Η πλατφόρμα μας δημιουργήθηκε με έναν στόχο, να φέρει τους καταναλωτές πιο κοντά στις πραγματικές προσφορές. Δίνουμε τη δυνατότητα στους χρήστες να ανακαλύπτουν, να μοιράζονται και να αξιολογούν γνήσιες προσφορές από καταστήματα γύρω τους, κάνοντας τις έξυπνες αγορές πιο εύκολες και διαδραστικές από ποτέ.",
    whatTitle: "Τι κάνουμε",
    whatText: "Μέσω της εφαρμογής μας, οι χρήστες μπορούν να εξερευνήσουν κοντινές τους προσφορές, να δημοσιεύσουν τα δικά τους ευρήματα, να εξατομικεύσουν τις ειδοποιήσεις τους, να διαχειριστούν το προφίλ τους και να αποθηκεύσουν τις αγαπημένες τους προσφορές, όλα από ένα διαισθητικό περιβάλλον. Όλοι μπορούν να συνεισφέρουν σε μια κοινότητα που βασίζεται στο μοίρασμα και την εξοικονόμηση.",
    whyTitle: "Γιατί το κάνουμε",
    whyText: "Πιστεύουμε ότι οι μεγάλες προσφορές προορίζονται για να μοιράζονται. Συνδέοντας τους ανθρώπους με τα τοπικά καταστήματα, βοηθούμε τους χρήστες να εξοικονομήσουν χρήματα υποστηρίζοντας παράλληλα τις τοπικές επιχειρήσεις. Η πλατφόρμα μας δεν αφορά μόνο τις εκπτώσεις, αλλά την οικοδόμηση μιας συνεργατικής και ενημερωμένης κοινότητας έξυπνων αγοραστών."
  },
  en: {
    title: "About us",
    whoTitle: "Who we are",
    whoText: "Our platform was created with one goal in mind, to bring consumers and real discounts closer together. We empower users to discover, share, and rate genuine deals from stores around them, making smart shopping easier and more interactive than ever.",
    whatTitle: "What we do",
    whatText: "Through our app, users can explore nearby discounts, post their own findings, personalize notifications, manage their profiles, and save their favorite offers, all from one intuitive place. Everyone can contribute to a community built on sharing and saving.",
    whyTitle: "Why we do it",
    whyText: "We believe that great deals are meant to be shared. By connecting people and local stores, we help users save money while supporting local businesses. Our platform isn’t just about discounts, it’s about building a collaborative, informed community of smart shoppers."
  }
};

const About = () => {
  //Initialize language state from localStorage, defaults to 'el' if not set
  const [lang, setLang] = useState(localStorage.getItem("app_lang") || "el");

  //Listener to update language whenever the language button in HeaderA is clicked
  useEffect(() => {
    const handleStorageChange = () => {
      setLang(localStorage.getItem("app_lang") || "el");
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const t = translations[lang];

  return (
    <div className="min-h-screen bg-custom-background flex flex-col">
      <Header />

      <main id="main-content" className="flex-1 flex flex-col items-center justify-center px-6 md:px-16 py-10">
        <div id="about-card" className="max-w-4xl bg-gradient-to-b from-custom-grad1 via-custom-grad2 via-custom-grad3 to-custom-grad4 p-8 md:p-12 rounded-3xl shadow-lg text-white">
          
          {/* Title */}
          <h1 className="text-3xl md:text-4xl font-bold mb-6 text-center">{t.title}</h1>

          {/* Who We Are */}
          <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">{t.whoTitle}</h2>
            <p className="text-base leading-relaxed">
              {t.whoText}
            </p>
          </section>

          {/* What We Do */}
          <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">{t.whatTitle}</h2>
            <p className="text-base leading-relaxed">
              {t.whatText}
            </p>
          </section>

          {/* Why We Do It */}
          <section className="mb-6">
            <h2 className="text-2xl font-semibold mb-2">{t.whyTitle}</h2>
            <p className="text-base leading-relaxed">
              {t.whyText}
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default About;